import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  divider: {
    marginBlock: 16
  }
}))
